import React from "react";
import RadioButton from "./radio-button";

const Address = ({
	index,
	setDefaultAddress,
	deactivateAddress,
	// Only the checkout drawer has one to close; the address book has none.
	setShippingDrawerOpen = undefined,
	countries,
	radioButton = true,
	...address
}) => {
	const {
		countryId,
		isDefault,
		locality,
		region,
		line1,
		line2,
		zipCode,
		fullName,
		id,
	} = address;

	const countryNameFromId = (id) => {
		if (countries.length === 0 || !id) return "";
		const country = countries.filter((c) => c.id == id);
		return country[0]?.name;
	};

	/**
	 * Choosing an address is a click anywhere on it, not on the radio alone.
	 *
	 * The whole card reads as one option -- name, street, the radio beside it --
	 * and only the 30px button was live, so a tap on the address itself did
	 * nothing at all.
	 */
	// Only wired up when the card is an option (radioButton).
	const chooseThis = () => {
		setDefaultAddress(id);
		setTimeout(() => {
			if (setShippingDrawerOpen) setShippingDrawerOpen(false);
		}, 1000);
	};

	// if (!line1) return "";
	return (
		<div
			className={`address ${radioButton ? "address-option" : ""} ${
				isDefault ? "defaultAddress" : ""
			}`}
			data-testid={`address-${id}`}
			{...(radioButton
				? {
						onClick: chooseThis,
						role: "radio",
						"aria-checked": !!isDefault,
						tabIndex: 0,
						onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								chooseThis();
							}
						},
				  }
				: {})}
		>
			{radioButton ? (
				<div
					className="button-cont"
					// No handler of its own: a click here bubbles to the card's,
					// which counts it once.
					data-testid={`set-default-address-${id}`}
				>
					<RadioButton
						setButton={() => {
							// The card handles the click.
						}}
						button={isDefault}
					/>
				</div>
			) : (
				""
			)}
			<div className="text">
				<span className="name">
					{fullName} <br />
				</span>
				<span className="highlight">
					{line1}
					<br />
					{line2 ? line2 : ""}
					{line2 ? <br /> : ""}
					{locality},&nbsp;{region},&nbsp;{zipCode}
					<br />
					{countryNameFromId(countryId)}
					<br />
				</span>
			</div>
			{deactivateAddress ? (
				<div
					className="delete-button"
					data-testid={`delete-address-${id}`}
					onClick={(e: React.MouseEvent<HTMLDivElement>) => {
						// Deleting is not choosing: the card's handler must not
						// also run and make this address the default on its way out.
						e.stopPropagation();
						deactivateAddress(address);
					}}
				>
					{"✕"}
				</div>
			) : (
				""
			)}
		</div>
	);
};

export default Address;
